import React from 'react';
import { motion } from 'framer-motion';
import logo from '../assets/logo.jpg';

/**
 * Footer component con animaciones.
 * Proporciona información de contacto y derechos de autor.
 */
export default function Footer() {
  return (
    <footer id="contacto" className="bg-primary text-white py-8 mt-12">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-start md:items-center space-y-4 md:space-y-0"
      >
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          <div className="flex items-center gap-3 mb-3">
            <img
              src={logo}
              alt="Su Carne Logo"
              className="h-16 w-16 rounded-full object-cover shadow-lg"
            />
            <h3 className="text-2xl font-bold">Su Carne</h3>
          </div>
          <h4 className="text-xl font-bold mb-2">📞 Contacto</h4>
          <p className="mb-1">
            WhatsApp:{' '}
            <motion.a
              whileHover={{ scale: 1.05 }}
              href="https://wa.me/59892696366"
              className="underline hover:text-secondary transition-colors"
            >
              092&nbsp;696&nbsp;366
            </motion.a>
          </p>
          <p>📍 Ubicación: 28 de Febrero esquina Rivera</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="text-sm"
        >
          &copy; {new Date().getFullYear()} Su Carne. Todos los derechos reservados.
        </motion.div>
      </motion.div>
    </footer>
  );
}